module.exports = __webpack_public_path__ + "img/plus.c767ee98.svg";